import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import IconButton from 'components/atoms/Button/IconButton';
import { disableAllMenu,isActiveUsabilityModal,isActiveFeedbackModal,isACtiveSatisfyModal,activeCount } from 'modules/actions/statusMenu';
import { sendUsaAbility } from 'modules/actions/starUsability';

const Usability = () => {
  const dispatch = useDispatch();
  const StarName = ['전혀 그렇지 않다', '그렇지 않다', '보통', '그렇다', '매우 그렇다'];
  const grade = [20,40,60,80,100];

  // (3). 마지막으로 클릭한 bot_message 상태값 가져오기.
  const usabilityAnswer = useSelector(state => state.usability);
  const messageId = useSelector(state => state.quality.messageId);
  const [payloadStatus, setPayloadStatus] = useState(usabilityAnswer);
  const clickedBotMessage = useSelector(state => state.quality.clickedBotMessage);

  const closeUsability = () => {
    dispatch(isActiveUsabilityModal(false));
    dispatch(isACtiveSatisfyModal({
      isSatisfyModal:false
    }));
    dispatch(activeCount({ setActiveYn:false }));
    setPayloadStatus(usabilityAnswer);
  };

  const closeModalFocus = () => {

    const botElement = document.querySelector(`div[name="${clickedBotMessage}"]`);
    const opinionElement = botElement.querySelectorAll('._chat_opinion')[1]

    if (opinionElement) {
      opinionElement.setAttribute('tabindex', '0');
      opinionElement.focus();
    }
  };

  const setStarValue = (key, scoreStr, contentStr, transGrade) => {
    setPayloadStatus(prevState => ({
      ...prevState,
      answer: {
        ...prevState.answer,
        [key]: {
          ...prevState.answer[key],
          score: Number(scoreStr),  // score를 숫자로 변환
          content: contentStr,
          grade: grade[transGrade]
        }
      }
    }));
  };
  return (
    <div className="_usability_bg">
      <div className="feedback_area">
        <i
          className="ri-close-line"
          role="button"
          tabIndex={2}
          title="닫기 버튼"
          onClick={closeUsability}
        />
        <div className="fd_name_title">사용편의성 조사</div>

        <div className="fd_name">• 서비스의 메뉴가 명확하게 구분되어 있습니까?</div>
        <div className="star_set">
          {StarName.map((name, i) => (
            <IconButton
              key={`_star_${i + 'a' + 1}`}
              clickEvt={() => {
                setStarValue("type_1", i + 1, name, i);
              }}
              icon={payloadStatus.answer.type_1.score >= i + 1 ? 'ri-star-fill' : 'ri-star-line'}
              styleDef={{ width: '40px', fontSize: '40px', height: '40px', color: '#BE314B' }}
              tabIndex="1"
            />
          ))}
        </div>
        <div className="fd_name">{payloadStatus.answer.type_1.content}</div>
        <div className="fd_name">• 아이콘, 색상, 글꼴 등이 보기에 편리합니까?</div>
        <div className="star_set">
          {StarName.map((name, i) => (
            <IconButton
              key={`_star_${i + 'b' + 1}`}
              clickEvt={() => {
                setStarValue("type_2",i + 1, name, i);
              }}
              icon={payloadStatus.answer.type_2.score >= i + 1 ? 'ri-star-fill' : 'ri-star-line'}
              styleDef={{ width: '40px', fontSize: '40px', height: '40px', color: '#BE314B' }}
              tabIndex="1"
            />
          ))}
        </div>
        <div className="fd_name">{payloadStatus.answer.type_2.content}</div>
        <div className="fd_name">• 서비스의 응답속도가 적정합니까?</div>
        <div className="star_set">
          {StarName.map((name, i) => (
            <IconButton
              key={`_star_${i + 'c' + 1}`}
              clickEvt={() => {
                setStarValue("type_3",i + 1, name,i);
              }}
              icon={payloadStatus.answer.type_3.score >= i + 1 ? 'ri-star-fill' : 'ri-star-line'}
              styleDef={{ width: '40px', fontSize: '40px', height: '40px', color: '#BE314B' }}
              tabIndex="1"
            />
          ))}
        </div>
        <div className="fd_name">{payloadStatus.answer.type_3.content}</div>
        <div
          className="fd_send_btn"
          role="button"
          tabIndex={1}
          onClick={() => {
            if (!sessionStorage.getItem('usability_status')) {
              sessionStorage.setItem('usability_status', 'N');
            }
            payloadStatus.id.botId=messageId
            if (sessionStorage.getItem('usability_status') === 'Y') {
              const sign = window.confirm('이미 사용편의성 평가를 완료하셨습니다. 수정하시겠습니까?');
              if (sign) {
                dispatch(sendUsaAbility(payloadStatus));
                setPayloadStatus(
                  usabilityAnswer
                );
              }
            } else {
              // alert(JSON.stringify(payloadStatus,null,2))
              dispatch(sendUsaAbility(payloadStatus));
              setPayloadStatus(
                usabilityAnswer
              );
              sessionStorage.setItem('usability_status', 'Y');
            }
            dispatch(isActiveUsabilityModal(false));
            dispatch(isACtiveSatisfyModal({
              isSatisfyModal:false
            }));
          }}
          onKeyPress={e => {
            if (e.key === 'Enter') {
              if (!sessionStorage.getItem('usability_status')) {
                sessionStorage.setItem('usability_status', 'N');
              }
              payloadStatus.id.botId=messageId
              if (sessionStorage.getItem('usability_status') === 'Y') {
                const sign = window.confirm('이미 사용자편의성 평가를 완료하셨습니다. 수정하시겠습니까?');
                if (sign) {
                  dispatch(sendUsaAbility(payloadStatus));
		  dispatch(activeCount({ setActiveYn:false }));
                  setPayloadStatus(
                    usabilityAnswer
                  );
                }
              } else {
                dispatch(sendUsaAbility(payloadStatus));
                setPayloadStatus(
                  usabilityAnswer
                );
	        dispatch(activeCount({ setActiveYn:false }));
                sessionStorage.setItem('usability_status', 'Y');
              }
              dispatch(disableAllMenu());
            }
          }}
        >
          확인
        </div>
      </div>
    </div>
  );
};

export default Usability;
